// Brand marquee — clean rows of individual circular client logos.
// Add new entries to LOGOS as the client sends individual PNG files.
const LOGOS = [
  { src: "/assets/jetour-logo.png", alt: "Jetour" },
  { src: "/assets/client-1.png", alt: "Cliente ModoRedes" },
  { src: "/assets/client-2.png", alt: "Cliente ModoRedes" },
  { src: "/assets/client-3.png", alt: "Cliente ModoRedes" },
  { src: "/assets/client-4.png", alt: "Heinz" },
  { src: "/assets/client-5.png", alt: "Colgate" },
  { src: "/assets/client-6.png", alt: "Farmatodo" },
  { src: "/assets/client-7.png", alt: "Daka" },
  { src: "/assets/client-8.png", alt: "RE/MAX" },
  { src: "/assets/client-9.png", alt: "Aruba Airlines" },
  { src: "/assets/client-10.png", alt: "Splazate" },
  { src: "/assets/client-11.png", alt: "Mini-me" },
  { src: "/assets/client-12.png", alt: "Universidad" },
  { src: "/assets/client-13.png", alt: "La Otra Liga" },
  { src: "/assets/client-14.png", alt: "Palazzo" },
  { src: "/assets/client-15.png", alt: "Fly Travel" },
  { src: "/assets/client-zentec.png", alt: "Zentec" },
  { src: "/assets/client-17.png", alt: "All Grill" },
  { src: "/assets/client-18.png", alt: "French's Gold" },
  { src: "/assets/client-19.png", alt: "Roofing World" },
  { src: "/assets/client-20.png", alt: "Santa María del Campo" },
];

const CircleRow = ({ logos, duration = "40s", reverse = false }) => {
  // Repeat enough times to fill the row visually
  const filled = [];
  const min = Math.max(10, logos.length * 8);
  for (let i = 0; i < min; i++) filled.push(logos[i % logos.length]);
  const loop = [...filled, ...filled];

  return (
    <div className="overflow-hidden relative">
      <div
        className={`flex items-center gap-8 sm:gap-12 w-max marquee-track ${reverse ? "marquee-reverse" : ""}`}
        style={{ animationDuration: duration }}
      >
        {loop.map((logo, i) => (
          <div
            key={i}
            data-testid={`brand-logo-${i}`}
            className="shrink-0 h-20 w-20 sm:h-24 sm:w-24 rounded-full overflow-hidden bg-white ring-1 ring-[color:var(--mr-line)] flex items-center justify-center transition-transform duration-300 hover:scale-105"
          >
            <img
              src={`${logo.src}?v=9`}
              alt={logo.alt}
              loading="lazy"
              className="w-full h-full object-contain select-none pointer-events-none"
              draggable={false}
            />
          </div>
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 w-16 sm:w-24 bg-gradient-to-r from-white to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-16 sm:w-24 bg-gradient-to-l from-white to-transparent pointer-events-none" />
    </div>
  );
};

export const LogoMarquee = () => {
  return (
    <section className="relative py-14 sm:py-20 border-y border-[color:var(--mr-line)] bg-white">
      <div className="max-w-5xl mx-auto px-5 mb-8 sm:mb-12 flex items-baseline gap-3 flex-wrap">
        <span className="mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[color:var(--mr-muted)]">
          [ marcas ·
        </span>
        <h3 className="display text-[22px] sm:text-[30px] leading-none">
          que han <span className="text-[color:var(--mr-purple)]">confiado</span> en nosotros
        </h3>
        <span className="mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[color:var(--mr-muted)]">
          ]
        </span>
      </div>

      <div className="space-y-5 sm:space-y-7">
        <CircleRow logos={LOGOS.filter((_, i) => i % 2 === 0)} duration="400s" />
        <CircleRow logos={LOGOS.filter((_, i) => i % 2 === 1)} duration="450s" reverse />
      </div>
    </section>
  );
};
